import * as Yup from 'yup'

export const loginFormFormSchema = Yup.object({
    email: Yup.string().email('Email is Invalid').required('Required'),
    password: Yup.string().required('Required')
})